<template>
  <a-modal
    :title="formTitle || '新增版本'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <a-form
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="APP类型:" name="appType">
            <a-select placeholder="请选择" v-model:value="form.appType">
              <a-select-option value="0">安卓</a-select-option>
              <a-select-option value="1">苹果</a-select-option>
              <a-select-option value="2">通用</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="版本号名称" name="versionName">
            <a-input
              v-model:value="form.versionName"
              placeholder="请输入版本号名称(15字)"
              :maxLength="15"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="版本号" name="versionCode">
            <a-input
              v-model:value="form.versionCode"
              placeholder="请输入版本号"
              :maxLength="15"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="更新包大小" name="upHeSize">
            <a-input-number
              style="width: 100%"
              v-model:value="form.upHeSize"
              placeholder="请输入更新包大小"
              :min="0.01"
              :maxLength="10"
              :max="9999"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="更新地址类型:" name="upUrlType">
            <a-select placeholder="请选择" v-model:value="form.upUrlType">
              <a-select-option value="0">内部</a-select-option>
              <a-select-option value="1">其它(应用市场)</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="更新类型:" name="upType">
            <a-select placeholder="请选择" v-model:value="form.upType">
              <a-select-option value="0">热更新</a-select-option>
              <a-select-option value="1">整包更新</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="强制升级否" name="compulsoryUp">
            <a-select placeholder="请选择" v-model:value="form.compulsoryUp">
              <a-select-option value="0">强制</a-select-option>
              <a-select-option value="1">可跳过</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="更新说明" name="upNotes">
            <a-input
              v-model:value="form.upNotes"
              placeholder="请输入更新说明"
              :maxLength="30"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="下载地址" name="downloadUrl">
            <a-input
              v-model:value="form.downloadUrl"
              placeholder="请输入下载地址"
              :maxLength="500"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 占位，保持布局平衡 -->
        </a-col>
      </a-row>

      <a-row :gutter="12" v-if="form.upUrlType == 1">
        <a-col :span="24">
          <a-form-item
            label="其它(应用市场)应用 【内部使用文件库】"
            name="upUrl"
          >
            <a-input
              v-model:value="form.upUrl"
              placeholder="请输入其它(应用市场)应用 【内部使用文件库】"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import {
  getVersionInfo,
  addVersionInfo,
  updateVersionInfo,
} from '@/api/app/versionInfo'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

const emit = defineEmits(['ok'])

const formRef = ref()
const submitLoading = ref(false)
const formTitle = ref('')
const formType = ref(1)
const open = ref(false)
const loading = ref(false)
const apkFileName = ref(null)

const form = reactive({
  id: null,
  appType: '0',
  upNotes: null,
  upHeSize: null,
  upUrlType: null,
  upUrl: null,
  versionName: null,
  versionCode: null,
  upType: null,
  compulsoryUp: null,
  downloadUrl: null,
  createTime: null,
  remark: null,
})

const rules = {
  appType: [
    {
      required: true,
      message: 'APP类型 : 0安卓 1苹果 2通用不能为空',
      trigger: 'change',
    },
  ],
  upUrlType: [
    {
      required: true,
      message: '更新地址类型: 0内部 1其它(应用市场)不能为空',
      trigger: 'change',
    },
  ],
  versionCode: [
    {
      required: true,
      message: '版本号不能为空',
      trigger: 'blur',
    },
  ],
  upType: [
    {
      required: true,
      message: '更新类型: 0热更新 1整包更新不能为空',
      trigger: 'change',
    },
  ],
  compulsoryUp: [
    {
      required: true,
      message: '强制升级否 0强制 1可跳过不能为空',
      trigger: 'blur',
    },
  ],
  downloadUrl: [
    {
      required: true,
      message: '下载地址不能为空',
      trigger: 'blur',
    },
  ],
}

function onClose() {
  open.value = false
}

function cancel() {
  open.value = false
  reset()
}

function reset() {
  formType.value = 1
  Object.assign(form, {
    id: null,
    appType: '0',
    upNotes: null,
    upHeSize: null,
    upUrlType: null,
    upUrl: null,
    versionName: null,
    versionCode: null,
    upType: null,
    compulsoryUp: null,
    downloadUrl: null,
    createTime: null,
    remark: null,
  })
  apkFileName.value = null
}

function handleAdd(row) {
  reset()
  formType.value = 1
  open.value = true
  formTitle.value = '添加'
}

function handleUpdate(row, ids) {
  reset()
  formType.value = 2
  const id = row ? row.id : ids
  getVersionInfo({ id: id }).then((response) => {
    Object.assign(form, response.data)
    open.value = true
    formTitle.value = '修改'
  })
}

async function submitForm() {
  try {
    await formRef.value.validate()
    submitLoading.value = true
    if (form.id !== undefined && form.id !== null) {
      await updateVersionInfo(form)
      message.success('修改成功', 3)
      open.value = false
      emit('ok')
    } else {
      await addVersionInfo(form)
      message.success('新增成功', 3)
      open.value = false
      emit('ok')
    }
  } catch (error) {
    return false
  } finally {
    submitLoading.value = false
  }
}

function fileBeforeUpload(fileInfo) {
  // 图片类型字段, 进行文件类型判断
  // Log.info('fileInfo', fileInfo);
  // if (!fileInfo.type.includes('apk') || !fileInfo.type.includes('wgt')) {
  //   message.warning('请上传更新包');
  //   return false;
  // }
  return true
}

function fileUploadRequest(fileInfo) {
  // Note: Log is not imported, may need to be added if used
  // Log.info('uploadfileInfo', fileInfo)
  loading.value = true
  new UploadFileToOSS([fileInfo.file], {
    finally: (res) => {
      // Log.info('upload', res)
      loading.value = false
      form.downloadUrl = res[0].url
      apkFileName.value = null
    },
  })
}

defineExpose({
  handleAdd,
  handleUpdate,
})
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0 !important;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 60px 24px !important;
  overflow-x: hidden !important;
  max-width: 100% !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form {
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 100% !important;
  overflow-x: hidden !important;
}

/* Label 文字左对齐，与输入框左边对齐 */
.create-form-modal .ant-form-item-label {
  padding-right: 0 !important;
  text-align: left !important;
}

.create-form-modal .ant-form-item-label > label {
  text-align: left !important;
  justify-content: flex-start !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 确保表单项不会超出 */
.create-form-modal .ant-form-item {
  margin-bottom: 24px !important;
  overflow: visible !important;
  width: 100% !important;
  max-width: 100% !important;
}

.create-form-modal .ant-form-item-control {
  max-width: 100% !important;
  overflow: hidden !important;
  width: 100% !important;
}

/* 富文本编辑器外层容器 - 防止超出 */
.create-form-modal .ant-form-item-control-input-content {
  width: 100% !important;
  max-width: 100% !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>
